import { render, staticRenderFns } from "./AutomationScheduleModal.vue?vue&type=template&id=2220f89d&scoped=true&"
import script from "./AutomationScheduleModal.vue?vue&type=script&lang=ts&"
export * from "./AutomationScheduleModal.vue?vue&type=script&lang=ts&"
import style0 from "./AutomationScheduleModal.vue?vue&type=style&index=0&id=2220f89d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2220f89d",
  null
  
)

export default component.exports